<script>
  export default {
    computed: {
      currentConference() {
        return this.$store.state.conference.currentConference
      },
    },
    created() {
      if (this.$store.getters["auth/isTokenValid"]) {
        this.$store.dispatch("conference/getCurrentConference").then(() => {})
      }
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === "auth/AUTH_UPDATE_TOKEN") {
          if (this.$store.getters["auth/isTokenValid"]) {
            this.$store.dispatch("conference/getCurrentConference")
          }
        }
      })
    },
  }
</script>
